/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Filter_All_ProvidersInputs */



/**
* | output |
* | --- |
* | "All Providers" |
*
* @param {Spaces_Filter_All_ProvidersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_filter_all_providers = /** @type {((inputs?: Spaces_Filter_All_ProvidersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Filter_All_ProvidersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Anbieter")
	return /** @type {LocalizedString} */ ("All Providers")
});